import { ChevronDown, ChevronRight } from 'react-feather';

const OrderInstallerSection = ({
	sections,
	toggleSection,
	orderDetails,
	currentUser,
	register,
	handleInstaller,
	installers,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('installerTab', e)}
				>
					<h2 className="title-h2">Installer</h2>
					<button type="button">
						{sections.installerTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.installerTab && (
					<>
						<div className="content-block mb-10">
							<p>
								<strong>Installer:</strong>
							</p>
							<p>{orderDetails.workOrder?.installerName}</p>
						</div>

						{currentUser?.role === 'SUPER' && (
							<div className="field-section-full">
								<div className="inp-col inline-block relative max-w-xs">
									<label htmlFor="installerId">
										<strong>Assign or Change an installer</strong>
									</label>
									<select
										{...register('installerId')}
										onChange={handleInstaller}
										className="block appearance-none w-full bg-white border  hover:border-gray-500 hover:cursor-pointer mt-4 px-4 py-2  rounded shadow leading-tight focus:outline-none focus:shadow-outline"
									>
										<option value="">Select installer</option>
										{installers?.map((installer) => (
											<option key={installer.id} value={installer.id}>
												{installer?.firstName} {installer?.lastName}
											</option>
										))}
									</select>
									<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 mt-10 text-gray-700">
										<ChevronDown size={24} />
									</div>
								</div>
							</div>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default OrderInstallerSection;
